/* eslint-disable camelcase */
import { useMemo } from 'react';
import PropTypes from 'prop-types';
import { results } from '@mdc/ui';
import OldSandboxNetwork from './OldSandboxNetwork';
import OpswatSandboxNetwork from './OpswatSandboxNetwork';

import './Network.scss';

const { PlainTablePlaceholder } = results;

const Network = ({ sandboxResults, resultsLoading, scanning, fileImage }) => {
    const networkDetails = useMemo(() => sandboxResults?.data?.details?.data?.network || { ...sandboxResults?.data?.details?.networking_analysis?.bro, 'geolocation': sandboxResults?.data?.details?.geolocation }, [sandboxResults]);

    const processRawData = (data, meta, isPlainTable = false) => {
        if (!isPlainTable) {
            // Maintain backward compatibility
            return meta.filter((row) => Object.hasOwnProperty.call(data, row.accessor) && (data[row.accessor] || typeof data[row.accessor] === 'number'))
                .map((row) => {
                    let value = row.parser ? row.parser(data[row.accessor]) : data[row.accessor];
                    return { field: row.header, data: value };
                });
        }

        return data.map((entry) => {
            return meta.filter((row) => Object.hasOwnProperty.call(entry, row.accessor) && (entry[row.accessor] || typeof entry[row.accessor] === 'number'))
                .reduce((previous, row) => {
                    let value = entry[row.accessor];

                    if (row.parser) {
                        value = row.parser(entry[row.accessor]);
                    } else if (row.mergeAccessorParser) {
                        const mergeAccessors = row.mergeAccessors.map((accessor) => {
                            const mergeAccessorValue = entry[accessor.key];
                            return { key: accessor.key, symbol: accessor.symbol, value: mergeAccessorValue };
                        });

                        value = row.mergeAccessorParser(entry[row.accessor], mergeAccessors);
                    }

                    return { ...previous, [row.accessor]: value };
                }, {});
        });
    };

    const sandboxDom = useMemo(() => {
        if (!sandboxResults?.data) {
            return <PlainTablePlaceholder numberOfColumns={6}/>;
        }

        if (sandboxResults?.data?.summary) {
            return <OldSandboxNetwork
                sandboxResults={sandboxResults}
                resultsLoading={resultsLoading}
                scanning={scanning}
                fileImage={fileImage}
                networkDetails={networkDetails}
                processRawData={processRawData}
            />;
        }

        return <OpswatSandboxNetwork
            resultsLoading={resultsLoading}
            scanning={scanning}
            networkDetails={networkDetails}
            processRawData={processRawData}
        />;
    }, [sandboxResults, resultsLoading, scanning, fileImage, networkDetails]);

    return <>{sandboxDom}</>;
};

Network.propTypes = {
    sandboxResults: PropTypes.object,
    resultsLoading: PropTypes.bool,
    scanning: PropTypes.string,
    fileImage: PropTypes.object.isRequired
};

export default Network;
